import {
  Component,
  Input,
  Output,
  EventEmitter,
  Inject,
  HostBinding
} from '@angular/core';
import * as _ from 'lodash';

@Component({
  moduleId: module.id,
  selector: 'search-results-row',
  templateUrl: 'search-results-row.component.html',
  styleUrls: ['search-results-row.component.scss']
})
export class SearchResultsRowComponent {
  @Input() row: any;
  @Input() columns: Array<{}> = [];
  @Input() disableItemSelect: boolean = false;
  @Input() rowStatusHidden: boolean = false;
  @Input() selectable: boolean = false;
  @Input() detailsBtnText: string = 'View details';
  @Input() showIconForEmptyVal: boolean = false;
  @Input() tooltipTextsMap: any;
  @Input() hideActionButton: boolean = false;
  @Input() isVersion2: boolean = false;
  @Input() timezone: any;

  @HostBinding('class.status-removed')
  @Input() statusRemoved: boolean = false; // remove status renderer from DOM

  @Output() changeCheckbox = new EventEmitter<{}>();
  @Output() detailsBtnClick = new EventEmitter<{}>();
  @Output() rowClick = new EventEmitter<{}>();
  @Output() checkboxClick = new EventEmitter<{}>();
  @Output() infoIconClick = new EventEmitter<{}>();
  @Output() highlightedValueClick = new EventEmitter<{}>();
  @Output() linkClick = new EventEmitter<{}>();

  debouncedCheckboxClick = _.debounce(this.emitCheckboxClick, 50);

  onCheckboxChange(event: any, column: any) {
    column.selected = event.target.checked;
    this.changeCheckbox.emit(column);
  }

  onClickDetailsBtn(row: any) {
    localStorage.setItem('scrollTop', window.pageYOffset.toString());
    this.detailsBtnClick.emit(row._id);
  }

  onRowClick(event: any, row: any) {
    if (this.selectable) {
      event.currentTarget.classList.add('selected');
    }
    this.rowClick.emit(row);
  }

  onCheckboxClick(event: any, row: any) {
    this.debouncedCheckboxClick(row);
  }

  onLinkClick($event: any) {
    this.linkClick.emit($event);
  }

  // private:
  private emitCheckboxClick(row: any) {
    this.checkboxClick.emit(row);
  }
}
